export const firstName = (user) => {
  const name = (user?.name || "").trim();
  if (name && name.toLowerCase() !== "cornerstone admin") return name.split(/\s+/)[0];
  const local = (user?.email || "").split("@")[0];
  if (!local) return "there";
  const cleaned = local.replace(/[._-]+/g, " ").replace(/\d+/g, "").trim();
  return cleaned ? cleaned.split(/\s+/)[0].replace(/^./, (c) => c.toUpperCase()) : "there";
};
